<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";

export default {
  page() {
    return {
      title: this.title,
      meta: [{ name: "description" }],
    };
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: "",
      items: [],
      userinfo: {},
      loading: false,
      binding: false,
      unbinding: false,
      portal: {
        bound: false,
        bind_status: "unbound",
        cloud_account_name: "",
      },
    };
  },
  computed: {
    statusTagType() {
      return this.portal.bound ? "success" : "info";
    },
    statusLabel() {
      if (this.portal.bound) {
        return this.$t("menuitems.clouds.cloudbind.bound");
      }
      return this.$t("menuitems.clouds.cloudbind.unbound");
    },
    accountDisplay() {
      if (this.portal.cloud_account_name) {
        return this.portal.cloud_account_name;
      }
      return this.$t("menuitems.clouds.cloudbind.account_unknown");
    },
  },
  mounted() {
    this.title = this.$t("menuitems.clouds.cloudbind.text");
    this.items = [
      { text: this.$t("menuitems.clouds.text"), href: "/" },
      { text: this.title, active: true },
    ];
    this.userinfo = JSON.parse(localStorage.getItem("user") || "{}");
    this.handleBindQuery();
    this.fetchStatus();
  },
  methods: {
    post(action, payload) {
      return this.$axios.post(
        this.apiuri,
        Object.assign({ action: action }, payload || {}),
        { headers: { Openid: this.userinfo.openid } }
      );
    },
    applyPortalData(data) {
      if (!data) return;
      this.portal = Object.assign({}, this.portal, data);
    },
    handleBindQuery() {
      const result = this.$route.query.bind;
      if (result === "success") {
        this.$message({
          message: this.$t("menuitems.clouds.cloudbind.bind_success"),
          type: "success",
        });
        this.$router.replace({ path: this.$route.path });
        this.fetchStatus();
      } else if (result === "fail") {
        this.$message.error(this.$t("menuitems.clouds.cloudbind.bind_fail"));
        this.$router.replace({ path: this.$route.path });
      }
    },
    fetchStatus() {
      var that = this;
      that.loading = true;
      that.post("syncbindportalstatus")
        .then(function (response) {
          if (response.data.status === 200 && response.data.data) {
            that.applyPortalData(response.data.data);
          }
        })
        .finally(function () {
          that.loading = false;
        });
    },
    startBind() {
      var that = this;
      if (that.portal.bound) return;
      that.binding = true;
      that.post("syncbindportalstart")
        .then(function (response) {
          var bindUrl =
            response.data.data &&
            (response.data.data.bind_url || response.data.data.authorize_url);
          if (response.data.status === 200 && bindUrl) {
            window.location.href = bindUrl;
            return;
          }
          that.$message.error(that.$t("menuitems.clouds.cloudbind.bind_fail"));
        })
        .catch(function () {
          that.$message.error(that.$t("menuitems.clouds.cloudbind.bind_fail"));
        })
        .finally(function () {
          that.binding = false;
        });
    },
    confirmUnbind() {
      var that = this;
      that.$confirm(
        that.$t("menuitems.clouds.cloudbind.unbind_confirm"),
        that.$t("menuitems.clouds.cloudbind.unbind_action"),
        {
          type: "warning",
          confirmButtonText: that.$t("menuitems.clouds.cloudbind.unbind_action"),
          cancelButtonText: "取消",
        }
      )
        .then(function () {
          that.doUnbind();
        })
        .catch(function () {});
    },
    doUnbind() {
      var that = this;
      that.unbinding = true;
      that.post("syncbindportalunbind")
        .then(function (response) {
          if (response.data.status === 200) {
            that.$message.success(
              that.$t("menuitems.clouds.cloudbind.unbind_success")
            );
            that.applyPortalData(response.data.data || { bound: false, cloud_account_name: "" });
            that.fetchStatus();
            return;
          }
          that.$message.error(that.$t("menuitems.clouds.cloudbind.unbind_fail"));
        })
        .catch(function () {
          that.$message.error(that.$t("menuitems.clouds.cloudbind.unbind_fail"));
        })
        .finally(function () {
          that.unbinding = false;
        });
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row justify-content-center" v-loading="loading">
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body text-center py-4">
            <div class="d-flex align-items-center justify-content-center mb-4">
              <h4 class="card-title mb-0 mr-3">{{ $t("menuitems.clouds.cloudbind.title") }}</h4>
              <el-tag :type="statusTagType">{{ statusLabel }}</el-tag>
            </div>

            <p class="text-muted mb-4">{{ $t("menuitems.clouds.cloudbind.desc_simple") }}</p>

            <div v-if="portal.bound" class="mb-4">
              <p class="text-muted mb-1">{{ $t("menuitems.clouds.cloudbind.cloud_account_label") }}</p>
              <h5 class="mb-0">{{ accountDisplay }}</h5>
            </div>

            <div class="d-flex justify-content-center flex-wrap" style="gap: 12px">
              <el-button
                v-if="!portal.bound"
                type="primary"
                :loading="binding"
                @click="startBind"
              >
                {{ $t("menuitems.clouds.cloudbind.bind_action") }}
              </el-button>
              <el-button
                v-if="portal.bound"
                type="danger"
                plain
                :loading="unbinding"
                @click="confirmUnbind"
              >
                {{ $t("menuitems.clouds.cloudbind.unbind_action") }}
              </el-button>
              <el-button @click="fetchStatus">{{ $t("menuitems.clouds.nfcreader.refresh") }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
